import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const hasSubscriptionAccess = (user) => {
  if (!user) return false;
  if (user.isSubscribed) return true;
  if (!user.currentPeriodEnd) return false;

  const periodEnd = new Date(user.currentPeriodEnd);
  if (Number.isNaN(periodEnd.getTime())) return false;
  return periodEnd.getTime() > Date.now();
};


const PublicRoute = () => {
 const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }
  

  if (user) {
    return user.role === "admin" 
      ? <Navigate to="/admin/dashboard" replace /> 
      : <Navigate to={hasSubscriptionAccess(user) ? "/user/dashboard" : "/pricing"} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
